module.exports = __webpack_public_path__ + "img/key-words.94e06b77.png";